/** Guest auth pages where an unauthenticated 401 must not trigger login redirect. */
const PUBLIC_AUTH_ROUTES = new Set([
  '/login',
  '/auth/login',
  '/register',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/accept-invite',
  '/auth/verify-email',
  '/login-by-token',
])

/** Token-in-path guest pages: the token is the whole credential, so any path under these roots. */
const PUBLIC_TOKEN_ROUTES = ['/sign', '/verify']

function isPublicTokenRoute(pathname: string): boolean {
  return PUBLIC_TOKEN_ROUTES.some(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  )
}

export function isPublicAuthRoute(pathname: string): boolean {
  return PUBLIC_AUTH_ROUTES.has(pathname) || isPublicTokenRoute(pathname)
}

/** Invite / reset links must stay reachable even when another session cookie exists. */
export function isTokenBasedGuestRoute(
  pathname: string,
  query: Record<string, unknown> | undefined,
): boolean {
  const token = query?.token
  if (typeof token !== 'string' || !token.trim()) {
    return false
  }
  return pathname === '/auth/accept-invite' || pathname === '/auth/reset-password'
}
